import { IUserTypingMessageEvent } from 'APP/model/group/groupModel.types';
import Entities from 'STORE';

export async function handleUserTypingMessage(data: IUserTypingMessageEvent): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(data.groupId);
  if (!group) {
    return;
  }

  group.userTyping.add(data);
}
